import { ALLIANZ_VARS } from './config'
import { dictionaryResponse } from './dictionary/dictionaryResponse'
import { add34 } from './helpers/add34'
import { addOrigingLeadTag } from './helpers/addOrigingLeadTag'
import { changeUTMparamsForTracking } from './helpers/changeUTMparamsForTracking'
import { customDSA } from './helpers/customDSA'
import { deleteCookies } from './helpers/deleteCookies'
// import { modalIsClient } from './helpers/modalIsClient'  --> modal antigua
import { modalIsClient2 } from './helpers/modalLogic'
import { setGenerateLeadTag } from './helpers/modalLogic/setGenerateLeadTag'
import { setOriginLeadCMB } from './helpers/modalLogic/setOriginLeadCMB'
import { notLoadDMV } from './helpers/notLoadDMV'
import { openModalNativeButtons } from './helpers/openModalNativeButtons'
import { getChangeURL, reloadDRPForSPA } from './helpers/reloadDRPForSPA'
import { activeModalInDevice, openModal } from './helpers/showModal'
// import { getValueName, showNameInModal } from './helpers/showNameInThanksModal' --> modal antigua
import { updateTagsForDRPLeads } from './helpers/updateLeadsForDRP'
import { objectIsVoid, pickElement, pickElementById } from './helpers/utils'
import { setDeclarativesForStorage } from './helpers/setDeclarativesForStorage'

export function App() {
  const DEFAULT_DL_VALUE = 'Not value in DL'

  const DATALAYER_VALUES = {
    ORIGIN:
      window?._satellite?.getVar('digitalData.page.pageinfo.origen') ??
      DEFAULT_DL_VALUE,
    RAMO:
      window?._satellite?.getVar('digitalData.page.pageinfo.ramo') ??
      DEFAULT_DL_VALUE,
    PRODUCT:
      window?._satellite?.getVar('digitalData.page.pageinfo.producto') ??
      DEFAULT_DL_VALUE,
    ID_LANDING:
      window?._satellite?.getVar('digitalData.page.pageinfo.IDlanding') ??
      DEFAULT_DL_VALUE
  }

  const allianzFormActions = localStorage.getItem('allianzFormActions')
  if (
    (window.location.href == 'https://www.allianz.es/t/quote-test.html' ||
      window.location.href.indexOf('https://calcularseguro.allianz.es/') >=
        0) &&
    allianzFormActions
  ) {
    const allianzFormActionsJSON = JSON.parse(allianzFormActions)
    DATALAYER_VALUES.ORIGIN = allianzFormActionsJSON.origen
    DATALAYER_VALUES.RAMO = allianzFormActionsJSON.ramo
    DATALAYER_VALUES.PRODUCT = allianzFormActionsJSON.product
    DATALAYER_VALUES.ID_LANDING = allianzFormActionsJSON.idLanding
  }

  if (typeof statusDFI !== 'object') {
    window.statusDFI = {}
  }
  window.statusDFI.loadPlatformsIds = true

  window.DFI = {}

  if (typeof window.dataLayer === 'undefined') window.dataLayer = []

  window.DFI.idTag = ALLIANZ_VARS.idTagDFI

  if (typeof window.DFI_client !== 'object') window.DFI_client = {}

  DFI_client.isWeekend = function () {
    const today = new Date()
    const dayOfWeek = today.getDay()
    const currentHour = today.getHours()

    if (
      (dayOfWeek === 5 && currentHour >= 20) ||
      (dayOfWeek === 6 && currentHour < 17)
    ) {
      DFI_client.convertion_type = 'true'
    } else {
      DFI_client.convertion_type = 'false'
    }
  }

  DFI_client.isWeekend()

  notLoadDMV()
  changeUTMparamsForTracking()
  window.DFI_client.defaultPhone = ALLIANZ_VARS.defaultPhone

  /* CONSTANTES URL COCHE Y MOTO : HORARIO DE 18 A 22 */

  window.DFI_client.urlScheduleList = [
    {
      url: 'seguros/landing/moto/seguros-de-moto-w',
      hourStart: '1',
      hourEnd: '24'
    },
    {
      url: 'seguros/landing/coche/seguros-de-coches-w',
      hourStart: '1',
      hourEnd: '24'
    },
    {
      url: 'seguros/landing/moto/seguro-ciclomotor',
      hourStart: '1',
      hourEnd: '24'
    }
  ]

  window.DFI_client.urlSchedule = function (urlScheduleList) {
    let output = true
    urlScheduleList.forEach((element) => {
      if (
        window.location.href.indexOf(element.url) > -1 &&
        !window.DFI_client.scheduleValid(element.hourStart, element.hourEnd)
      ) {
        output = false
      }
    })
    return output
  }

  window.DFI_client.getCookie = function (name) {
    const match = document.cookie.match(new RegExp(name + '=([^;]+)'))
    if (match) return match[1]
  }

  window.DFI_client.getUrlVar = function (variable, url) {
    const href = url || window.location.search
    let pair
    const query = href.split('?')[1]
    const vars = query ? query.split('&') : []

    for (let i = 0; i < vars.length; i++) {
      pair = vars[i].split('=')
      if (pair[0] === variable && pair[1] !== '') return pair[1]
    }

    return ''
  }

  window.DFI_client.scheduleValid = function (hourStart, hourEnd) {
    const now = new Date()
    const day = now.getDay()
    const hour = now.getHours()
    const dateDay = now.getDate()
    const month = now.getMonth()

    // Festivos lo deshabilitamos el mes hasta 12
    let isDayOff = false
    const daysOff = {
      inmaculada: {
        day: 8,
        month: 15
      },
      constitucion: {
        day: 6,
        month: 15
      },
      navidad: {
        day: 25,
        month: 15
      },
      navidad1: {
        day: 26,
        month: 15
      },
      anio_nuevo: {
        day: 1,
        month: 15
      },
      reyes: {
        day: 6,
        month: 15
      },
      'viernes-santo': {
        day: 14,
        month: 15
      }
    }

    for (const name in daysOff) {
      if (daysOff[name].month - 1 === month && daysOff[name].day === dateDay) {
        isDayOff = true
      }

      if (isDayOff) return false

      if (day >= 0 && day <= 8 && hour >= hourStart && hour <= hourEnd) {
        return true
      }
    }

    return false
  }

  // DataLayer

  const walmericFacebookId = window.DFI_client.getUrlVar('fbclid')

  const walmericFbc = window.DFI_client.getCookie('_fbc')
  const walmericFbp = window.DFI_client.getCookie('_fbp')

  if (walmericFacebookId.length > 5) {
    window.DFI_client.facebookId = walmericFacebookId
  } else if (
    typeof walmericFbc !== 'undefined' &&
    walmericFbc.length > 20 &&
    typeof walmericFbc.split('.')[3] !== 'undefined'
  ) {
    window.DFI_client.facebookId = walmericFbc.split('.')[3]
  } else if (
    typeof Fbp !== 'undefined' &&
    walmericFbp.length > 20 &&
    typeof walmericFbp.split('.')[3] !== 'undefined'
  ) {
    window.DFI_client.facebookId = walmericFbp.split('.')[3]
  }

  const stateCheck = setInterval(function () {
    if (
      document.readyState === 'complete' &&
      window.LoadedSript === undefined
    ) {
      window.LoadedSript = 'loaded'
      clearInterval(stateCheck)

      /**
       * dictionary
       */

      try {
        dictionaryResponse()
      } catch (error) {
        console.error('no dictionary')
      }

      loadAll()
    }
  }, 100)

  // window.landingsTypes = {}

  function loadAll() {
    // ------------------------------------------
    // OBJETO DE CONFIGURACION
    // ------------------------------------------

    const ALLIANZ = {
      idtag:
        '29842f94d414949bf95fb2e6109142cfef1fb2a78114c2c536a36bf5a65b953ad166f73ba5bb731373e838e4746a136e8ee2d1c67a22a2668b430a6a58178cbc080cf2d1786ca6b1085b7781e2e28b79e6eb2e3cd39bbb670b21c1ee6b150d9d1cb398ca0e7dfb25d594510dbe08a665',
      PATH: {
        D1C: 'https://t.womtp.com/slider/c/delio-lm/dfi/init.js',
        customStyles: 'https://t.womtp.com/slider/c/allianz/src/css/style.css',
        customStylesTest: 'https://t.womtp.com/slider/c/allianz/src/css/style_test.css',
        wsLeadUpdate:
          'https://ws.walmeric.com/provision/wsclient/delioClientLeadId_put.html',
        //iconTel: 'https://t.womtp.com/slider/c/allianz/src/img/iconotel.png',
        iconTel: 'https://t.womtp.com/slider/c/allianz/src/img/Phone_Call_24px.png'
      },
      DSA: {
        id: 'dsa-allianz'
      },
      NODES: {
        buttonPresupuestoAllianz: document.querySelectorAll(
          '#cta_landing_telefono_coche'
        )
      },
      EDeclarativesValues: {
        formOrigin: {
          presupuesto: 'Pide tu presupuesto'
        }
      },
      horario: {
        inicio: 1,
        fin: 24
      }
    }

    // El horario de Allianz.horario.inicio hace una comprobacion con el horario actual , este no contempla horas . El horario del objeto que pongas es el que mostrara el dsa //

    // ------------------------------------------
    // CARGAMOS DELIO ONE CLICK y Estilos
    // ------------------------------------------

    updateTagsForDRPLeads()

    window.idTagDelio = ALLIANZ.idtag
    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.src = ALLIANZ.PATH.D1C
    const head = document.getElementsByTagName('head')[0]
    head.appendChild(script)

    const cssId = 'customStyles'
    if (!document.getElementById(cssId)) {
      const head = document.getElementsByTagName('head')[0]
      const link = document.createElement('link')
      link.id = cssId
      link.rel = 'stylesheet'
      link.type = 'text/css'
      link.href = ALLIANZ.PATH.customStyles
      link.media = 'all'
      head.appendChild(link)
    }

    //customDSA()

    // ------------------------------------------
    // FLUJO DE EJECUCION
    // ------------------------------------------

    // Añade etiquetas declarativas a los formularios Call me Back

    // Modificamos styles DSA Desktop
    const startTime = Date.now()
    const isDSALoad = setInterval(() => {
      const now = Date.now()
      const DSA = document.querySelector('.dsa')
      if (DSA) {
        clearInterval(isDSALoad)
        
        document.querySelectorAll('.dsa-close').forEach((img) => {
          img.setAttribute('alt', 'cerrar formulario')
          img.setAttribute('style', 'display:none')
        })
      } else if (now - startTime >= 10000) {
        clearInterval(isDSALoad)
      }
    }, 300)

    // Modificamos styles DSA Movil

    const isDSAMobileLoad = setInterval(() => {
      const DSAM = document.querySelector('#dmv_bar')

      if (DSAM) {
        // !Elimina la imagen del DSA
        if (window.innerWidth < 704) {
          const callNowBtn = document.getElementById('ringPoolCha')

          if (callNowBtn) {
            setInterval(() => {
              callNowBtn.firstChild.nodeName === 'IMG' &&
                callNowBtn.firstChild.remove()
            }, 50)
          }
        }

        // !Elimina la barra blanca que tapaba los botones
        // if (document.querySelectorAll('#dmv_bar')) {
        //   const DSAVoid = document.querySelectorAll('#dmv_bar')
        //   DSAVoid[1] && DSAVoid[1].remove()
        // }

        document.querySelectorAll('#dmv_bar img').forEach(function (elemim) {
          elemim.remove()
        })

        clearInterval(isDSAMobileLoad)
      }
    }, 300)

    // Pisamos boton Calcula tu presupuesto y lanzamos nuestro CMB dentro de horario

    const presupuestoButtonsLoad = setInterval(() => {
      if (
        ALLIANZ.NODES.buttonPresupuestoAllianz &&
        typeof DFI !== 'undefined' &&
        typeof window.DFI.scheduleValidAll !== 'undefined'
      ) {
        clearInterval(presupuestoButtonsLoad)
        ALLIANZ.NODES.buttonPresupuestoAllianz.forEach((elem) => {
          if (window.DFI.scheduleValidAll(window.DFI.validSchedule)) {
            return false
          }
          elem.addEventListener('click', (event) => {
            event.preventDefault()
            window.DFI.ModalView.open()
          })
        })
      }
    })

    function procesarUTMSource() {
      // Verificar si ya se ha ejecutado
      const yaEjecutado = localStorage.getItem('yaEjecutado')

      if (!yaEjecutado) {
        // Paso 1: Extraer el valor de `utm_source` de los parámetros de la URL
        const [, utmSourceValue] = window.location.search
          .split('&')
          .filter((param) => param.includes('utm_source'))
          .join('')
          .split('=')

        // Paso 2: Verificar si `utm_source` es 'econtact'
        if (utmSourceValue === 'econtact') {
          deleteCookies()
          // Marcar como ya ejecutado en el almacenamiento local
          localStorage.setItem('yaEjecutado', 'true')
        }
      }
    }
    procesarUTMSource()

    // Pinta la modal de privacidad

    const privacidadAllianz = () => {
      const modalPrivacidad = document.createElement('div')
      modalPrivacidad.style.display = 'block'
      modalPrivacidad.innerHTML = `
                     <div id="allianz-privacity">
                       <div id="container">
                         <div id="topCloseIcon" class="closeModal">X</div>
                           <h2>Advertencia legal</h2>
                           <div id="allianz-privacity-block">
                             <p>A continuación le mostramos la <strong>Información Básica</strong> sobre Protección de Datos.</p>
                             <p><strong>Responsable: </strong>Allianz Compañía de Seguros y Reaseguros, S.A.</p>
                             <p><strong>Finalidad: </strong>Contactar con Ud. a los efectos de poder ofrecerle un presupuesto personalizado y, de haber obtenido su consentimiento, enviarle información comercial sobre nuestras ofertas y productos.</p>
                             <p><strong>Legitimación: </strong>Consentimiento del interesado.</p>
                             <p><strong>Destinatarios: </strong>El agente de seguros especificado.</p>
                             <p><strong>Derechos: </strong>Acceso, rectificación, supresión y portabilidad de los datos; limitación u oposición a su tratamiento, de acuerdo con las indicaciones contenidas en la información adicional.</p>
                             <p><strong>Periodo de conservación de los datos: </strong>3 meses.</p>
                             <p>En Allianz Seguros usamos cookies propias y de terceros para proporcionar un mejor servicio. Seleccionando el check aceptas de forma explícita el uso de las mismas. Para más información, puedes consultar este <a style="font-weight: 600;" href="https://www.allianz.es/informacion-legal.html#cookies">enlace</a></p>
                             <p>Puede consultar la <strong>Información Adicional</strong> y detallada sobre Protección de Datos en nuestra página web: </p>
                             <a class="cookiesLink" target="_blank" href="https://www.allianz.es/informacion-legal.html">https://www.allianz.es/informacion-legal.html</a>
                           </div>
                         <button id="allianz-privacity-buttonClose" class="closeModal">Cerrar</button>
                       </div>
                     </div>
                        `

      const parentModal = document.querySelector('#dmv-overlay')
      parentModal.appendChild(modalPrivacidad)

      const closeModal = document.querySelectorAll('.closeModal')
      closeModal.forEach((elem) => {
        elem.addEventListener('click', () => {
          modalPrivacidad.style.display = 'none'
        })
      })
    }
    const privacidadAllianzFR = () => {
      const modalPrivacidad = document.createElement('div')
      modalPrivacidad.style.display = 'block'
      modalPrivacidad.innerHTML = `
                     <div id="allianz-privacity">
                       <div id="container">
                         <div id="topCloseIcon" class="closeModal">X</div>
                           <h2>Avis légal</h2>
                           <div id="allianz-privacity-block">
                             <p>Ci-dessous, nous vous présentons les Informations de Base sur la Protection des Données.</p>
                             <p><strong>Responsable: </strong>Allianz Société d'Assurances et de Réassurances, S.A.</p>
                             <p><strong>Objectif: </strong>Vous contacter afin de vous proposer un devis personnalisé et, si vous avez donné votre consentement, vous envoyer des informations commerciales sur nos offres et produits.</p>
                             <p><strong>Légitimité: </strong>Consentement de la personne concernée</p>
                             <p><strong>Destinataires: </strong>L'agent d'assurance spécifié.</p>
                             <p><strong>Droits: </strong>Accès, rectification, suppression et portabilité des données ; limitation ou opposition à leur traitement, conformément aux indications contenues dans les informations supplémentaires.</p>
                             <p><strong>Période de conservation des données: </strong>3 mois.</p>
                             <p>Chez Allianz Assurances, nous utilisons nos propres cookies ainsi que ceux de tiers pour fournir un meilleur service. En sélectionnant la case, vous acceptez explicitement leur utilisation. Pour plus d'informations<a style="font-weight: 600;" href="https://www.allianz.es/fr/information-legale.html#cookies">vous pouvez consulter ce</a></p>
                             <p>Vous pouvez consulter <strong>les Informations Additionnelles</strong> et détaillées sur la Protection des Données sur notre site web: </p>
                             <a class="cookiesLink" target="_blank" href="https://www.allianz.es/fr/information-legale.html">https://www.allianz.es/fr/information-legale.html</a>
                           </div>
                         <button id="allianz-privacity-buttonClose" class="closeModal">fermer</button>
                         
                       </div>
                     </div>
                        `

      const parentModal = document.querySelector('#dmv-overlay')
      parentModal.appendChild(modalPrivacidad)

      const closeModal = document.querySelectorAll('.closeModal')
      closeModal.forEach((elem) => {
        elem.addEventListener('click', () => {
          modalPrivacidad.style.display = 'none'
        })
      })
    }

    const privacityLoad = setInterval(() => {
      const privactyElems = document.querySelectorAll('.allianzPrivacity')
      if (privactyElems.length > 0) clearInterval(privacityLoad)
      for (let z = 0; z < privactyElems.length; z++) {
        privactyElems[z].addEventListener('click', (event) => {
          event.preventDefault()
          if (window.location.href.includes('allianz.es/fr')) {
            privacidadAllianzFR()
          } else {
            privacidadAllianz()
          }
        })
      }
    }, 500)

    // Ocultar o mostrar segun hora

    const isLoadElements = setInterval(() => {
      if (
        (document.querySelector('#dsa-allianz') &&
          document.querySelector('.c-button')) ||
        (document.querySelector('#dmv_bar') &&
          document.querySelector('.c-button'))
      ) {
        clearInterval(isLoadElements)

        // Te llamamos gratis oculto
        if (document.querySelector('#dsa-allianz')) {
          document.querySelector('#dsa-allianz').style = 'display:none'
        }
      }
    }, 200)

    const dsaExist = setInterval(() => {
      const modalForm = document.querySelector('#dmv-form')
      const submitModalForm = document.querySelector('#btnSubmit')
      if (modalForm && submitModalForm) {
        clearInterval(dsaExist)

        ramoOrigenRingpool()
      }
    }, 500)

    // Añadimos Ramo y origen para Callmeback (el cliente añade valores en el datalayer, al generarse un lead)

    const waitDFI_client = setInterval(() => {
      if (typeof DFI_client !== 'undefined') {
        clearInterval(waitDFI_client)

        window.DFI_client.customResponseOKEvent = function (response) {
          const ramo_origenValues = setInterval(() => {
            if (
              typeof DFI !== 'undefined' &&
              typeof window.DFI.labels !== 'undefined' &&
              typeof window.DFI.labels.EDeclaratives !== 'undefined' &&
              typeof window.dataLayer !== 'undefined'
            ) {
              clearInterval(ramo_origenValues)

              if (objectIsVoid(window.datalayer)) return

              window.dataLayer.forEach((elem) => {
                if (
                  typeof elem.origen !== 'undefined' &&
                  typeof elem.ramo !== 'undefined'
                ) {
                  const dataLead = {
                    EDeclaratives: {
                      origen: DATALAYER_VALUES.ORIGIN,
                      ramo: DATALAYER_VALUES.RAMO
                    },
                    EConversions: [
                      {
                        id: '0',
                        value: DATALAYER_VALUES.ORIGIN
                      },
                      {
                        id: '1',
                        value: DATALAYER_VALUES.RAMO
                      }
                    ]
                  }

                  const idleadupdate = window.DFI.getCookie('wIdlLead')
                    ? window.DFI.getCookie('wIdlLead')
                    : window.Piwik.getAsyncTracker().getVisitorId()
                  // typeof DFI.getCookie('wIdlLead') !== 'undefined'
                  const updateLead = setInterval(() => {
                    if (typeof idleadupdate !== 'undefined') {
                      clearInterval(updateLead)
                      window.DAL.Ajax({
                        type: 'jsonp',
                        url: ALLIANZ.PATH.wsLeadUpdate,
                        data: {
                          idTag: ALLIANZ.idtag,
                          leadId: idleadupdate,
                          data: encodeURIComponent(JSON.stringify(dataLead))
                        }
                      }).done(function (dataResp) {
                        console.log('DFI.updateLead() => resp', dataResp)
                        if (!window.location.pathname.includes('forms')) {
                          deleteCookies()
                        }
                      })
                    }
                  }, 500)
                }
              })
            }
          }, 500)
          const etiquetasDigitalData = setInterval(() => {
            if (
              typeof DFI !== 'undefined' &&
              typeof window.DFI.labels !== 'undefined' &&
              typeof window.DFI.labels.EDeclaratives !== 'undefined' &&
              typeof window.digitalData !== 'undefined'
            ) {
              clearInterval(etiquetasDigitalData)

              const dataLead = {
                EDeclaratives: {
                  origen: DATALAYER_VALUES.ORIGIN,
                  ramo: DATALAYER_VALUES.RAMO,
                  idlanding: DATALAYER_VALUES.ID_LANDING,
                  producto: DATALAYER_VALUES.PRODUCT,
                  acceptPrivacyPolicy: true
                },
                EConversions: [
                  {
                    id: '0',
                    value: DATALAYER_VALUES.ORIGIN
                  },
                  {
                    id: '1',
                    value: DATALAYER_VALUES.RAMO
                  }
                ]
              }

              const idleadupdate = window.DFI.getCookie('wIdlLead')
                ? window.DFI.getCookie('wIdlLead')
                : window.Piwik.getAsyncTracker().getVisitorId()
              // typeof DFI.getCookie('wIdlLead') !== 'undefined'
              const updateLead = setInterval(() => {
                if (typeof idleadupdate !== 'undefined') {
                  clearInterval(updateLead)
                  window.DAL.Ajax({
                    type: 'jsonp',
                    url: ALLIANZ.PATH.wsLeadUpdate,
                    data: {
                      idTag: ALLIANZ.idtag,
                      leadId: idleadupdate,
                      data: encodeURIComponent(JSON.stringify(dataLead))
                    }
                  }).done(function (dataResp) {
                    console.log('DFI.updateLead() => resp', dataResp)
                    if (!window.location.pathname.includes('forms')) {
                      deleteCookies()
                    }
                  })
                }
              }, 500)
            }
          }, 500)
        }
      }
    }, 500)

    // window.DFI.telefonoRingPoolActivo
    // window.DFI.DFI_configuration.services.serviceList.ringPool.phoneMask

    // DFI.buildMaskString(window.DFI.telefonoRingPoolActivo, window.DFI.DFI_configuration.services.serviceList.ringPool.phoneMask);

    // const waitDFI = setInterval(() => {
    //   if (
    //     typeof DFI !== 'undefined' &&
    //     typeof window.DFI.telefonoRingPoolActivo === 'string'
    //   ) {
    //     if (
    //       typeof window.DFI.environment !== 'undefined' &&
    //       window.DFI.environment === 'mobile'
    //     ) {
    //       if (
    //         (window.DFI.mostrarPie === 'ringpool' ||
    //           window.DFI.mostrarPie === 'ringpool+CMB') &&
    //         document.querySelector('#ringPoolCha img') !== null
    //       ) {
    //         clearInterval(waitDFI)

    //         document.getElementById('ringPoolCha').innerHTML =
    //           window.DFI.DFI_configuration.DSAs[
    //             window.DFI.resultShowRules.dsaId - 1
    //           ].config.dsaMsgCallNow

    //         // ringpool mobile
    //         const mobileNavbar = document.querySelector('.c-header__navigation')
    //         const DRPContainerMobile = document.createElement('div')
    //         DRPContainerMobile.setAttribute('id', 'ringpoolMobile')

    //         const DRPAnchor = document.createElement('a')
    //         DRPAnchor.innerHTML = window.DFI.buildMaskString(
    //           window.DFI.telefonoRingPoolActivo,
    //           window.DFI.DFI_configuration.services.serviceList.ringPool
    //             .phoneMask
    //         )
    //         DRPAnchor.setAttribute('href', 'tel:919498177')
    //         DRPAnchor.setAttribute('class', 'drp-phone-new wal-drp-phone')
    //         DRPAnchor.setAttribute('id', 'ringPoolMobileText')

    //         const DRPImagePhone = document.createElement('img')
    //         DRPImagePhone.setAttribute(
    //           'src',
    //           'https://t.womtp.com/slider/c/allianz/src/img/iconotel.png'
    //         )
    //         DRPImagePhone.setAttribute('id', 'ringpoolIconMobile')

    //         DRPContainerMobile.appendChild(DRPImagePhone)
    //         DRPContainerMobile.appendChild(DRPAnchor)
    //         mobileNavbar.appendChild(DRPContainerMobile)
    //       }
    //     } else {
    //       // desktop
    //       if (
    //         typeof DFI !== 'undefined' &&
    //         typeof window.DFI.telefonoRingPoolActivo === 'string'
    //       ) {
    //         // Creacion ringpool Desktop
    //         if (pickElement('.c-header-metabar__content')) {
    //           const getSelectorTypeLanding =
    //             pickElement('.c-header-metabar__service-link') === null
    //               ? '.c-header-metabar__content'
    //               : '.c-header-metabar__service-link'

    //           console.log(getSelectorTypeLanding)

    //           const ringpoolDesktopContainer = document.createElement('div')
    //           ringpoolDesktopContainer.setAttribute('id', 'ringpoolDesktop')

    //           const containerToInsertRingpool = pickElement(
    //             getSelectorTypeLanding
    //           )

    //           const phoneIcon = document.createElement('img')
    //           phoneIcon.setAttribute(
    //             'src',
    //             'https://t.womtp.com/slider/c/allianz/src/img/iconotel.png'
    //           )
    //           phoneIcon.setAttribute('id', 'ringpoolIconDesktop')

    //           const ringpoolNumber = document.createElement('a')

    //           ringpoolNumber.innerHTML = window.DFI.buildMaskString(
    //             window.DFI.telefonoRingPoolActivo,
    //             window.DFI.DFI_configuration.services.serviceList.ringPool
    //               .phoneMask
    //           )
    //           ringpoolNumber.setAttribute('href', 'tel:919498177')
    //           ringpoolNumber.setAttribute(
    //             'class',
    //             'drp-phone-new wal-drp-phone'
    //           )
    //           ringpoolNumber.setAttribute('id', 'ringPoolDesktopText')

    //           ringpoolDesktopContainer.appendChild(ringpoolNumber)
    //           ringpoolDesktopContainer.appendChild(phoneIcon)

    //           containerToInsertRingpool.appendChild(ringpoolDesktopContainer)
    //         }
    //       }
    //       clearInterval(waitDFI)
    //     }
    //   }
    // }, 100)

    // Añadimos Ramo y origen para Callmeback (el cliente añade valores en el datalayer, al hacer click sobre ringpool)

    const ramoOrigenRingpool = () => {
      const allRingpoolPhone = document.querySelectorAll('.wal-drp-phone')
      allRingpoolPhone.forEach((ringpool) => {
        ringpool.addEventListener('click', () => {
          setTimeout(() => {
            window.dataLayer.forEach((elem) => {
              if (
                typeof elem.origen !== 'undefined' &&
                typeof elem.ramo !== 'undefined'
              ) {
                const dataLead = {
                  EDeclaratives: {
                    origen: DATALAYER_VALUES.ORIGIN,
                    ramo: DATALAYER_VALUES.RAMO,
                    idlanding: DATALAYER_VALUES.ID_LANDING
                  },
                  EConversions: [
                    {
                      id: '0',
                      value: DATALAYER_VALUES.ORIGIN
                    },
                    {
                      id: '1',
                      value: DATALAYER_VALUES.RAMO
                    }
                  ]
                }

                console.log(dataLead)
                window.DAL.Ajax({
                  type: 'jsonp',
                  url:
                    window.DFI.global.sendRingPoolLabels +
                    'idTag=' +
                    window.DFI.DFI_configuration.idTagDelioClient +
                    '&idvisitor=' +
                    window.Piwik.getAsyncTracker().getVisitorId() +
                    '&labels=' +
                    encodeURIComponent(JSON.stringify(dataLead)) +
                    '&idServ=' +
                    window.DFI.servicioActivo1.serviceIdRingPool
                })
                  .done(function (responseRingPoolLabels) {
                    window.DFI.consoleLogDelio(
                      'sendRingPoolLabels OK: ' + responseRingPoolLabels
                    )
                    return true
                  })
                  .fail(function (responseRingPoolLabels) {
                    window.DFI.consoleLogDelio(
                      'sendRingPoolLabels NOK: ' + responseRingPoolLabels
                    )
                  })
              }
            })
          }, 1000)
        })
      })
    }

    ramoOrigenRingpool()
  }

  /**
   * !Muestra la modal dependiendo si es desktop o mobile
   */
  activeModalInDevice()

  /**
   * !Cargamos la nueva modal que pregunta si es cliente o no
   */

  const waitForD1CModal = setInterval(() => {
    if (pickElementById('dmv')) {
      clearInterval(waitForD1CModal)
      // modalIsClient() --> modal antigua
      // getValueName() --> modal antigua
      addOrigingLeadTag()
      setOriginLeadCMB()
      setGenerateLeadTag()
      add34()
      changeTextInEn()
      changeTextInFr()
      changeTextForDogs()
      changeTextForLifeInsurance()
    }
  }, 50)

  /**
   * !Recarga el ringpool para el renderizado de react en el tarificador
   */
  if (pickElement('.headerButtonsSt')) getChangeURL(reloadDRPForSPA)

  /**
   * Eliminar el DRP fuera de horario
   */

  // const waitForDRP = setInterval(() => {
  //   if (typeof window.DFI !== 'undefined') {
  //     clearInterval(waitForDRP)
  //     deleteOutHoursDRP()
  //   }
  // }, 500)

  const URL = 'https://www.allianz.es'

  if (window.location.origin === URL) {
    const links = document.querySelectorAll(
      'a[href="https://www.allianz.es/forms/tellamamos-w.html?origen=wl22301&ramo=9999&campaign=web&refext=SeguroGeneral"]'
    )

    links.forEach((link) => {
      link.removeAttribute('href')

      const waitForD1CModal = setInterval(() => {
        if (pickElementById('dmv')) {
          clearInterval(waitForD1CModal)
          openModal(link)
        }
      }, 50)
    })
  }

  /** Muestra la modal de gracias personalizada */
  const observer = new MutationObserver(() => {
    const spinner = document.querySelector('.sk-circle')
    window.leadDoneCorrect = true

    if (spinner) {
      // showNameInModal() --> modal antigua
      observer.disconnect()
    }
  })

  observer.observe(document.body, { childList: true, subtree: true })

  openModalNativeButtons()
  modalIsClient2()

  function changeTextInEn() {
    const { pathname } = window.location

    const getIsEnUrl = pathname.split('/').some((item) => item === 'en')

    const $mobileDSA = document.querySelector('#dmvText')

    if (getIsEnUrl && $mobileDSA !== null) {
      $mobileDSA.innerText = 'Request a call'
    }
  }
  function changeTextInFr() {
    const { pathname } = window.location

    const getIsEnUrl = pathname.split('/').some((item) => item === 'fr')

    const $mobileDSA = document.querySelector('#dmvText')

    if (getIsEnUrl && $mobileDSA !== null) {
      $mobileDSA.innerText = 'Demander un appel'
      $mobileDSA.style.fontSize = '16px'
    }
  }
  //   function changeTextForDogs() {
  //     const { pathname } = window.location;
  //     const isDogUrl = pathname.includes('perros');
  //     if (window.DFI.environment === "mobile" && isDogUrl){

  //     const $mobileDSA = document.querySelector('#dmvText');
  //     $mobileDSA.addEventListener('click', function (event) {
  //       // Prevenir cualquier otro comportamiento asociado al clic
  //       // event.stopImmediatePropagation();
  //       // Permitir la navegación al href
  //       window.location.href = $mobileDSA.href;

  //   });

  //     if (isDogUrl && $mobileDSA !== null) {
  //         $mobileDSA.innerText = 'CALCULAR PRECIO';
  //         $mobileDSA.href = 'https://protecciondatos.allianz.es/PetsWebview?context=%7B%22bot%22%3A+%7B%22id%22%3A+%22a44ad435-bbb7-4c70-a0a7-69b3ae4462e7%22%2C+%22name%22%3A+%22ALLIANZ_PRO_ES%22%7D%2C+%22user%22%3A+%7B%22id%22%3A+%2200000000-0000-0000-0000-000000000000%22%2C+%22imp_id%22%3A+%2234638930466%22%2C+%22username%22%3A+null%2C+%22extra_data%22%3A+%7B%22country%22%3A+%22ES%22%2C+%22retries%22%3A+0%2C+%22language%22%3A+%22es%22%7D%2C+%22provider_id%22%3A+%2200000000-0000-0000-0000-000000000000%22%7D%2C+%22_hubtype_api%22%3A+%22https%3A%2F%2Fapi.hubtype.com%22%2C+%22organization%22%3A+%22ALLIANZ%22%2C%22organization_id%22%3A+%22f69adfb8-ec6e-40df-9480-b48231227fa4%22%7D&';

  //         // Interceptar el evento de clic para evitar que se abra la modal
  //         $mobileDSA.addEventListener('click', function(event) {
  //             event.preventDefault();
  //             window.location.href = $mobileDSA.href;
  //         });
  //     }
  //     }

  // }
  function changeTextForDogs() {
    const { pathname, search } = window.location
    const isDogUrl = pathname.includes('perros')

    if (window.DFI.environment === 'mobile' && isDogUrl) {
      const $mobileDSA = document.querySelector('#dmvText')

      if ($mobileDSA !== null) {
        // Construir la nueva URL concatenando los parámetros de la URL actual
        const baseUrl =
          'https://protecciondatos.allianz.es/PetsWebview?context=%7B%22bot%22%3A+%7B%22id%22%3A+%22a44ad435-bbb7-4c70-a0a7-69b3ae4462e7%22%2C+%22name%22%3A+%22ALLIANZ_PRO_ES%22%7D%2C+%22user%22%3A+%7B%22id%22%3A+%2200000000-0000-0000-0000-000000000000%22%2C+%22imp_id%22%3A+%2234638930466%22%2C+%22username%22%3A+null%2C+%22extra_data%22%3A+%7B%22country%22%3A+%22ES%22%2C+%22retries%22%3A+0%2C+%22language%22%3A+%22es%22%7D%2C+%22provider_id%22%3A+%2200000000-0000-0000-0000-000000000000%22%7D%2C+%22_hubtype_api%22%3A+%22https%3A%2F%2Fapi.hubtype.com%22%2C+%22organization%22%3A+%22ALLIANZ%22%2C%22organization_id%22%3A+%22f69adfb8-ec6e-40df-9480-b48231227fa4%22%7D&'
        const newUrl = baseUrl + search
        $mobileDSA.href = newUrl
        $mobileDSA.innerText = 'CALCULAR PRECIO'

        // Interceptar el evento de clic para evitar que se abra la modal y redirigir
        $mobileDSA.addEventListener('click', function (event) {
          event.preventDefault()
          window.location.href = $mobileDSA.href
        })
      }
    }
  }
  if (window.location.href.includes('calcularseguro.allianz.es')) {
    const observerTari = new MutationObserver(function (
      mutationsList,
      observer
    ) {
      // Observamos la presencia del botón para abrir la modal
      const botonLlamada = document.querySelector('.custom-budget__submit')
      const telefonoInput = document.querySelector(
        'input[type="tel"][name="telefono"]'
      )
      DFI_client.defaultPhone = '911980488'

      // Comprobamos si el teléfono y el botón están en el DOM
      if (botonLlamada && telefonoInput) {
        botonLlamada.addEventListener('click', function () {
          // Aquí el teléfono ya ha sido rellenado en la modal
          var telefono = telefonoInput.value
          telefono = telefono.replace(/\s+/g, '')

          // Si no tiene el prefijo +34, lo añadimos
          if (telefono && !telefono.startsWith('+34')) {
            telefono = '34' + telefono
            telefonoInput.value = telefono
          }

          // Actualizamos el valor de teléfono en DFI
          if (window.DFI && DFI.labels && DFI.labels.EDeclaratives) {
            DFI.labels.EDeclaratives.phone = telefono
          }
        })

        // Desconectamos el observer porque ya se encontró lo necesario
        observer.disconnect()
      }
    })

    // Observamos el body de la página en busca de cualquier cambio, como la inserción de la modal
    observerTari.observe(document.body, {
      childList: true,
      subtree: true
    })
  }

  // function changeTextForLifeInsurance() {
  //   const { pathname, search } = window.location;

  //   // Lista de URLs permitidas
  //   const allowedUrls = [
  //     '/seguros/landing/vida/seguro-vida-tarificador-rtg.html',
  //     '/seguros/landing/vida/seguro-vida-joven-tarificador.html',
  //     '/seguros/landing/vida/seguro-vida-joven-tarificador-rtg.html',
  //     '/seguros/landing/vida/seguro-vida-55-tarificador.html',
  //     '/seguros/landing/vida/seguro-vida-55-tarificador-rtg.html',
  //     '/seguros-vida.html'
  //   ];

  //   // Verificar si la URL actual está en la lista de URLs permitidas
  //   const isAllowedUrl = allowedUrls.includes(pathname);

  //   if (window.DFI.environment === "mobile" && isAllowedUrl) {
  //     const $mobileDSA = document.querySelector('#dmvText');

  //     if ($mobileDSA !== null) {
  //       // Construir la nueva URL concatenando los parámetros de la URL actual
  //       const baseUrl = 'https://segurosdevida.allianz.es/webapp/client/';
  //       const newUrl = baseUrl + search;
  //       $mobileDSA.href = newUrl;

  //       // Interceptar el evento de clic para evitar que se abra la modal y redirigir
  //       $mobileDSA.addEventListener('click', function(event) {
  //         event.preventDefault();
  //         window.location.href = $mobileDSA.href;
  //       });
  //     }
  //   }
  // }
  function changeTextForLifeInsurance() {
    const { pathname, search } = window.location

    // Lista de URLs permitidas
    const allowedUrls = [
      '/seguros/landing/vida/seguro-vida-tarificador-rtg.html',
      '/seguros/landing/vida/seguro-vida-joven-tarificador.html',
      '/seguros/landing/vida/seguro-vida-joven-tarificador-rtg.html',
      '/seguros/landing/vida/seguro-vida-55-tarificador.html',
      '/seguros/landing/vida/seguro-vida-55-tarificador-rtg.html',
      '/seguros-vida.html'
    ]

    const currentUrl = window.location.href

    // Verificar si la URL actual está en la lista de URLs permitidas
    const isAllowedUrl = allowedUrls.includes(pathname)

    if (window.DFI.environment === 'mobile' && isAllowedUrl) {
      const $mobileDSA = document.querySelector('#dmvText')
      const callNowBtn = document.getElementById('ringPoolCha')

      if ($mobileDSA !== null) {
        // Comprobamos si la URL completa es exactamente 'https://www.allianz.es/seguros-vida.html'
        if (currentUrl === 'https://www.allianz.es/seguros-vida.html') {
          // Si es esta URL, solo cambiamos el color a 'var(--custom-budget-blue)'
          $mobileDSA.style.backgroundColor = 'var(--blue-7)'
          callNowBtn.style.backgroundColor = 'var(--orange-7)'
        } else {
          // Para las otras URLs, construimos la nueva URL concatenando los parámetros
          const baseUrl = 'https://segurosdevida.allianz.es/webapp/client/'
          const newUrl = baseUrl + search
          $mobileDSA.href = newUrl

          // Interceptar el evento de clic para evitar que se abra la modal y redirigir
          $mobileDSA.addEventListener('click', function (event) {
            event.preventDefault()
            window.location.href = $mobileDSA.href
          })
        }
      }
    }
  }

  if (
    window.location.href != 'https://www.allianz.es/' &&
    window.location.href != 'https://www.allianz.es/contacto.html'
  ) {
    var avoidRingPoolDefault = document.createElement('div')
    avoidRingPoolDefault.innerHTML =
      '<div class="drp-phone" style="display:none"></div>'
    var bodyEnd = document.getElementsByTagName('body')[0]
    bodyEnd.appendChild(avoidRingPoolDefault)
  }

  if (
    window.location.href == 'https://www.allianz.es/t/quote-test.html' ||
    window.location.href.indexOf('https://calcularseguro.allianz.es/') >= 0
  ) {
    let cambiosStorage = localStorage.getItem('allianzFormActions')

    window.addEventListener('storage', function (event) {
      if (localStorage.getItem('allianzFormActions') != cambiosStorage) {
        cambiosStorage = localStorage.getItem('allianzFormActions')

        setDeclarativesForStorage()
      }
    })

    const etiquetasDigitalData = setInterval(() => {
      if (
        typeof DFI !== 'undefined' &&
        typeof window.DFI.labels !== 'undefined' &&
        typeof window.DFI.labels.EDeclaratives !== 'undefined' &&
        typeof window.digitalData !== 'undefined' &&
        localStorage.getItem('allianzFormActions')
      ) {
        setDeclarativesForStorage()
        clearInterval(etiquetasDigitalData)
      }
    }, 1000)
  }
}
